import React, { useState, useEffect } from 'react';
import mp3File from '../../../../resources/sound.mp3';
import styles from './Header.module.css';
import constants from './constants';
import Tooltip from "rc-tooltip";

import option from "../../../../assets/images/Fireboard/option.png";
import resyncImg from '../../../../assets/images/Fireboard/resync.png';
import search from '../../../../assets/images/Fireboard/search_white.png';
import calendarImage from '../../../../assets/images/Fireboard/calendar_white.png';
import unpaidIcon from '../../../../assets/images/Fireboard/unpaid.png';
import snooze from '../../../../assets/images/Fireboard/snoozeSleep.png';
import notificationGif from '../../../../assets/images/Fireboard/bell.gif';
import logoutImage from '../../../../assets/images/logout/logout.png';
import notificationUnSelectedUnFilled from '../../../../assets/images/Fireboard/notificationfilled_white.png';
import notificationUnSelectedFilled from '../../../../assets/images/Fireboard/notificationfilled_orange.png';

import channels from '../../../../assets/images/Fireboard/menu_buttons/channels.png';
import filters from '../../../../assets/images/Fireboard/menu_buttons/filters.png';
import info from '../../../../assets/images/Fireboard/menu_buttons/info.png';
import outofstock from '../../../../assets/images/Fireboard/menu_buttons/outofstock.png';
import pairwatch from '../../../../assets/images/Fireboard/menu_buttons/pairwatch.png';
import scantopay from "../../../../assets/images/Fireboard/action_buttons/scantopay_white.png";
import texttopaydollar from "../../../../assets/images/Fireboard/action_buttons/texttopay_white.png";
import texttopayeuro from "../../../../assets/images/Fireboard/action_buttons/texttopayeuro_white.png";
import location from "../../../../assets/images/Fireboard/action_buttons/location_white.png";
import manager from "../../../../assets/images/Fireboard/action_buttons/preauth_white.png";
import diagnostics from '../../../../assets/images/Fireboard/menu_buttons/diagnostics.png';
import settings from '../../../../assets/images/Fireboard/settings.png';
import classNames from "classnames";
import EventEmitter from '../../../../util/event-emitter';

const audio = new Audio(mp3File);
audio.loop = true;

const tooltipInfo = [
    {
        id: 1,
        first: {
            id: 1,
            type: "managerLogin",
            name: "Manager"
        },
        second: {
            id: 3,
            type: "pairWatch",
            name: "Pair Watch"
        }
    },
    {
        id: 2,
        first: {
            id: 10,
            type: "checkIn",
            name: "Text to Check In",
        },
        second: {
            id: 5,
            type: "channels",
            name: "Channels",
        }
    },
    {
        id: 3,
        first: {
            id: 8,
            type: "textToPay",
            name: "Text To Pay",
        },
        second: {
            id: 6,
            type: "settings",
            name: "Filters",
        },
    },
    {
        id: 4,
        first: {
            id: 9,
            type: "payNow",
            name: "Scan To Pay",
        },
        second: {
            id: 2,
            type: "diagnostics",
            name: "Diagnostics"
        },
    },
    {
        id: 5,
        first: {
            id: 4,
            type: "outOfStock",
            name: "Out Of Stock"
        },
        second: {
            id: 11,
            type: "about",
            name: "About",
        },
    },
    {
        id: 6,
        first: {
            id: 7,
            type: "sort",
            name: "Settings",
        },
        second: {
            id: 8,
            type: "networkLogs",
            name: "Network Logs",
        },
    },
];

export default function Header(props) {
    // props
    const status = constants.status;
    const CURB_SIDE = 'Curbside';
    const ONLINE = 'Online';
    const WALK_UP = 'Walk up';
    const TEXT_TO_PAY = 'Call in';
    const STATUS_TYPE = 'status-type';
    const ORDER_TYPE = 'order-type';
    const PREP_TIME = 'Prep Time';
    const PRODUCTION = 'Production';

    const { managerFilters, onMgrFilterClick, activeMgrFilter, orderTypes, orderType, snoozeEnabled, snoozeNotifications, notificationCount, notificationControlEnabled, countStatus, totalNotificationsCount, showNotifications, selectedDate, onToggleCount, onOpenSearchBox, isFutureOrderType, showCalendar, curbCount, onlineCount, walkupCount, textToPayCount, curbPendingCount, onlinePendingCount, walkupPendingCount, textToPayPendingCount, prepTime, production, onFooterIconPress } = props;

    const { onChange, setNotifications, reSync, managerMode, onLogout, counters, toggleView, currency = '$' } = props;

    const [blinkAnim, setBlinkAnim] = useState(false);
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [selectedAction, setSelectedAction] = useState('');
    const allowFutureOrder = isFutureOrderType && selectedDate;

    useEffect(() => {
        if (notificationControlEnabled && notificationCount > 0) {
            if (!snoozeEnabled) {
                if (!window.ReactNativeWebView)
                    audio.play();
                else
                    EventEmitter.playAudio(true);
            }
            setBlinkAnim(true);
            return () => {
                if (!window.ReactNativeWebView)
                    audio && audio.pause();
                else 
                    EventEmitter.playAudio(false);
                setBlinkAnim(false);
            };
        }
    }, [notificationControlEnabled, snoozeEnabled, notificationCount]);

    const getDropdowns = () => {
        if (managerMode) {
            return (
                managerFilters.map(item => {
                    return (
                        <div className={styles.iconWrapper} key={item.key}>
                            <input type="checkbox" className={styles.checkbox} onClick={() => onMgrFilterClick(item)} checked={activeMgrFilter === item.key} />
                            <div className={styles.typeText}>{item.name}</div>
                        </div>
                    )
                })
            )
        }
        return (
            <div className={styles.container}>
                <select id="statusType" className={styles.dropdown} onChange={() => {
                    var ele = document.getElementById("statusType");
                    var value = ele.options[ele.selectedIndex].text;
                    onChange(STATUS_TYPE, value);
                }}>
                    {status.map(s => {
                        return <option key={`status-${s}`} className={styles.option}>{s}</option>
                    })}
                </select>

                <select id="orderType" className={styles.dropdown} onChange={() => {
                    var ele = document.getElementById("orderType");
                    var value = ele.options[ele.selectedIndex].text;
                    onChange(ORDER_TYPE, value);
                }}>
                    {orderTypes.map(s => {
                        return <option key={`orderType-${s}`} selected={orderType === s} className={styles.option}>{s}</option>
                    })}
                </select>
            </div>
        );
    };

    const getNotificationImage = () => {
        if (showNotifications) {
            if (notificationCount > 0) {
                return notificationUnSelectedFilled;
            }
            return notificationUnSelectedUnFilled;
        }
        if (notificationCount > 0) {
            return notificationUnSelectedFilled;
        }

        return notificationUnSelectedUnFilled;
    }

    const getSnoozeIcon = () => {
        if (notificationControlEnabled && notificationCount > 0) {
            if (!snoozeEnabled) {
                return (
                    <div className={{ ...styles.col2SubViewBell, width: '8%', marginLeft: 1 }}>
                        <img alt="snooze" className={styles.snoozeIcon} src={snooze} onClick={snoozeNotifications} />
                    </div>
                );
            }
        }
        return <div className={{ ...styles.col2SubViewBell, width: '8%' }} />;
    };

    const source = blinkAnim ? notificationGif : getNotificationImage();

    const checkVisibility = (name) => {
        return !counters.includes(name);
    }

    const getIcon = type => {
        switch (type) {
            case "managerLogin": return manager;
            case "pairWatch": return pairwatch;
            case "checkIn": return location;
            case "channels": return channels;
            case "textToPay": return currency === '£' ? texttopayeuro : texttopaydollar;
            case "settings": return filters;
            case "payNow": return scantopay;
            case "diagnostics": return diagnostics;
            case "outOfStock": return outofstock;
            case "about": return info;
            case "sort": return settings;
            case "networkLogs": return settings;
            default: return null;
        }
    };

    const renderOverlayContent = () => {
        return (
            <div className={styles.overlayContentContainer}>
                {tooltipInfo.map((tooltip) => {
                    const { first = {}, second = {}, id: rowId } = tooltip;
                    const { id: fId, name: fName, type: fType } = first;
                    const { id: sId, name: sName, type: sType } = second;
                    const disabled = managerMode && fType === 'managerLogin';
                    return (
                        <div key={`wrapper-${rowId}`} className={styles.tooltipBtnWrapper}>
                            {first && fType ? (
                                <div
                                    className={classNames({
                                        [styles.footerItem]: true,
                                        [styles.highligthtedAction]: selectedAction === fType && !disabled,
                                        [styles.disabledButton]: disabled
                                    })}
                                    key={`first-${fId}`}
                                    style={{ border: fId ? "" : "none" }}
                                    onClick={() => {
                                        if(!disabled) {
                                            onFooterIconPress(fType);
                                            setTooltipVisible(false);
                                        }
                                    }}
                                    onMouseEnter={() => setSelectedAction(fType)}
                                    onMouseLeave={() => setSelectedAction('')}
                                >
                                    <div className={styles.imgWrapper}>
                                        <img src={getIcon(fType)} className={styles.menuIcon} />
                                    </div>
                                    <span className={classNames({ [styles.tooltipTextStyle]: true, [styles.disabledTxt]: disabled })}>{fName}</span>
                                </div>
                            ) : null}
                            {second && sType ? (
                                <div
                                    className={classNames({
                                        [styles.footerItem]: true,
                                        [styles.highligthtedAction]: selectedAction === sType
                                    })}
                                    key={`second-${sId}`}
                                    style={{ border: sId ? "" : "none" }}
                                    onClick={() => {
                                        onFooterIconPress(sType);
                                        setTooltipVisible(false);
                                    }}
                                    onMouseEnter={() => setSelectedAction(sType)}
                                    onMouseLeave={() => setSelectedAction('')}
                                >
                                    <div className={styles.imgWrapper}>
                                        <img src={getIcon(sType)} className={styles.menuIcon} />
                                    </div>
                                    <span className={styles.tooltipTextStyle}>{sName}</span>
                                </div>
                            ) : null}
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <div className={styles.header}>
            <img src={resyncImg} className={styles.headerIcon} alt="sync" onClick={reSync} />
            <span className={styles.odLabel}>onedine</span>
            {!allowFutureOrder ? getDropdowns() : <span className={styles.odLabel}>Future Orders</span>}
            <img src={search} className={styles.headerIcon} alt="search" onClick={onOpenSearchBox} />
            {allowFutureOrder ? <img src={calendarImage} className={styles.headerIcon} alt="calendar" onClick={showCalendar} /> : null}
            <div className={styles.col2SubViewBell}>
                <img onClick={setNotifications} className={styles.notIcon} src={source} key={source} alt="source" />
                <div className={styles.notificationCountStyle}>
                    <span style={{ color: showNotifications && notificationCount !== 0 ? 'white' : 'black' }} className={[styles.notificationCountStyleText].join(' ')}>
                        {totalNotificationsCount}
                    </span>
                </div>
            </div>
            {getSnoozeIcon()}
            <Tooltip
                placement="bottomLeft"
                visible={tooltipVisible}
                overlay={renderOverlayContent()}
                trigger={"click"}
                overlayInnerStyle={{ padding: "0.93vh" }}
                onVisibleChange={(visible) => setTooltipVisible(visible)}
            >
                <img
                    data-tip="Settings"
                    src={option} className={styles.footerIcon} alt="settings" />
            </Tooltip>

            {managerMode ? (
                <div className={styles.col2StyleMgr}>
                    <span className={styles.managerText}>** MANAGER ** </span>
                    <img onClick={onLogout} className={styles.logoutStyle} src={logoutImage} alt="source" />
                </div>
            ) : (
                    <div className={styles.countContainer}>
                        <HeaderCount
                            header={CURB_SIDE}
                            color={curbCount > 0 ? 'green' : 'black'}
                            count={curbPendingCount}
                            showStopper={!countStatus.curbside}
                            visible={checkVisibility(CURB_SIDE)}
                            type="curbside"
                        />
                        <HeaderCount
                            header={ONLINE}
                            color={onlineCount > 0 ? 'green' : 'black'}
                            count={onlinePendingCount}
                            showStopper={!countStatus.online}
                            visible={checkVisibility(ONLINE)}
                            type="online"
                        />
                        <HeaderCount
                            header={TEXT_TO_PAY}
                            color={textToPayCount > 0 ? 'green' : 'black'}
                            count={textToPayPendingCount}
                            visible={checkVisibility(TEXT_TO_PAY)}
                            showStopper={false}
                        />
                        <HeaderCount
                            header={WALK_UP}
                            color={walkupCount > 0 ? 'green' : 'black'}
                            count={walkupPendingCount}
                            showStopper={!countStatus.walkup}
                            visible={checkVisibility(WALK_UP)}
                            type="walkup"
                        />
                        <HeaderCount
                            header="Prep time"
                            color="black"
                            count={prepTime}
                            showStopper={false}
                            visible={checkVisibility(PREP_TIME)}
                            type="prepTime"
                        />
                        <HeaderCount
                            header="Production"
                            color="black"
                            count={production}
                            showStopper={false}
                            type="productionRate"
                            visible={checkVisibility(PRODUCTION)}
                        />
                    </div>
                )}
        </div>
    );
}

const HeaderCount = countProps => {
    const { color, count, showStopper, header, type, visible } = countProps;
    if (!visible) return null
    return (
        <div className={type === 'production' ? styles.col2ProdSubView : styles.col2SubView}>
            <span className={type === 'production' ? styles.subViewProdTextStyle : styles.subViewTextStyle}>
                {header}
            </span>
            <span className={styles.subViewCountStyle} style={{ color }}>{count}</span>
            {showStopper ? <img src={unpaidIcon} className={styles.countStopper} alt="unpaid" /> : null}
        </div>

    );
};